import moment from 'moment';

const UserStateFilters = {
  state: (type, numDays) => ([
    {
      displayValue: 'State',
      name: 'state',
      operator: 'eq',
      value: type,
    }, {
      displayValue: 'Date',
      name: 'scheduled_date',
      operator: 'lt',
      value: moment().add(numDays, 'days').format('YYYY-MM-DD'),
    },
  ]),
  getId: id => ([{
    value: id,
    customType: 'or',
    name: '_id',
    operator: 'eq',
  }]),
};

export default UserStateFilters;
